var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.filters),function(filter,index){return _c('filter-field',{key:filter.id,model:{value:(_vm.filters[index]),callback:function ($$v) {_vm.$set(_vm.filters, index, $$v)},expression:"filters[index]"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }